import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import useApplicationTracker from "customHooks/useApplicationTracker";
import { ReactComponent as NovaIcon } from "resources/icons/nova.svg";
import "./NovaChatOptions.scss";

const CATEGORY_TITLES = {
  goal_creation: "Suggested prompts to get started in goals",
  team: "Suggested prompts to get started in Teams",
};

const THINKING_KEYWORDS = ["Thinking", "Assessing", "Creating"];

export const NovaThinkingLoader = () => {
  const [keywordIndex, setKeywordIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setKeywordIndex((prev) => (prev + 1) % THINKING_KEYWORDS.length);
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="nova-thinking-container">
      <div className="nova-thinking-content">
        <div className="nova-thinking-icon">
          <NovaIcon className="nova-robot-icon" />
        </div>
        <div className="nova-thinking-text">
          <span className="nova-thinking-label" key={keywordIndex}>
            {THINKING_KEYWORDS[keywordIndex]}
          </span>
          <span className="nova-thinking-dots">
            <span className="dot">.</span>
            <span className="dot">.</span>
            <span className="dot">.</span>
          </span>
        </div>
      </div>
    </div>
  );
};

const NovaChatOptions = ({ product, isAiLoading, setMessageText }) => {
  const { captureUserEvent } = useApplicationTracker();
  const { accountId } = useSelector((state) => state.user);
  const employeeName = useSelector((state) => state.user.employeeFirstName);
  const novaDefaultPrompts = useSelector(
    (state) => state?.aiFeatures?.goalsCreateWithNovaAI.defaultPrompts
  );

  const handleSelectDefaultPrompt = (prompt) => {
    setMessageText(prompt);
    captureUserEvent("nova_default_prompts_clicked", {
      accountId: accountId,
      prompt: prompt,
    });
  };

  const promptCategories = Object.keys(novaDefaultPrompts || {});

  return (
    <div className="ml-30 w-90 nova-chat-initial-promt">
      <p className="pl-8 mr-15 display-inlineblock">
        Hi {employeeName}, I&apos;m Nova your personal AI-powered assistant!
        I&apos;m here to help you create {product}. Select one of the option
        below to get started.
      </p>
      {isAiLoading ? (
        <div className="flex flex-col px-8 py-8 ml-8 nova-chat-options-wrapper">
          <NovaThinkingLoader />
        </div>
      ) : promptCategories.length > 0 ? (
        promptCategories.map((category) => (
          <div
            key={category}
            className="flex flex-col px-8 py-8 ml-8 nova-chat-options-wrapper mt-8"
          >
            <div className="nova-chat-options-title">
              {CATEGORY_TITLES[category] || `Suggested prompts for ${category}`}
            </div>
            {novaDefaultPrompts[category]?.map((prompt, index) => (
              <div
                key={index}
                className="cursor-pointer nova-chat-option "
                onClick={() => handleSelectDefaultPrompt(prompt)}
              >
                {prompt}
              </div>
            ))}
          </div>
        ))
      ) : (
        <div className="flex flex-col px-8 py-8 ml-8 nova-chat-options-wrapper">
          <div className="text-gray-500">No prompts available</div>
        </div>
      )}
    </div>
  );
};

export default NovaChatOptions;
